module.exports = __webpack_public_path__ + "img/deer-intro-icon.61aa765d.png";